import { AsyncPipe } from '@angular/common';
import { httpResource } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { EventService } from '../../services/event.service';
import { INewsArticleListResponseDto } from '../../shared/ystm-service-api-types';

@Component({
    selector: 'app-application-toolbar-content-icon-news',
    imports: [
        AsyncPipe,
        RouterLink,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule
    ],
    templateUrl: './application-toolbar-content-icon-news.component.html',
    styleUrl: './application-toolbar-content-icon-news.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationToolbarContentIconNewsComponent {
  readonly eventService = inject(EventService);
  newsResource = httpResource(
    () => ({
      url: `${environment.ystmServiceBaseUrl}/news/public`,
    }),
    { parse: (res: unknown) => (res as INewsArticleListResponseDto) || { newsArticles: [] } }
  );

}
